import StoreConfirmationModal from 'features/store/components/store-confirmation-modal';

export default function StoreConfirmation() {
  return <StoreConfirmationModal />;
}
